import { Routes } from '@angular/router';
import { FicheFormationComponent } from './components/fiche-formation/fiche-formation.component';
import { SearchComponent } from './components/search/search.component';
import { SearchResultComponent } from './components/search-result/search-result.component';

export const CatalogRouting: Routes = [
  {
    path: '',
    component: SearchComponent
  },
  {
    path: 'searchresult',
    component: SearchResultComponent
  },
  {
    path: 'formation',
    component: SearchResultComponent
  },
  {
    path: 'formation/:identifier',
    component: FicheFormationComponent
  }
];
